import { useEffect, useState } from 'react';
import { patientPortalApi } from '../api/patientPortal.api';

/** Loads faculty/staff capability flags for patient portal chrome. */
export default function usePatientCapabilities() {
  const [caps, setCaps] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let live = true;
    patientPortalApi.capabilities()
      .then((data) => { if (live) setCaps(data); })
      .catch(() => {
        if (live) {
          setCaps({
            is_faculty_staff: false,
            can_refer: false,
            can_view_family: false,
            can_book_dependents: false,
          });
        }
      })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, []);

  return { caps, loading, isFacultyStaff: Boolean(caps?.is_faculty_staff) };
}
